import { useEffect, useRef, useState } from "react";
import { ImagesMapping } from "Configurations/ImagesMapping";
import { getClientName, getImageDetails } from "Utils/GeneralUtils";
import { Button, Dialog } from "@material-ui/core";
import { connect } from "react-redux";
import { useStyles } from "./styles";
import { useHistory, useParams } from "react-router-dom";
import { Header } from "gce-cxinteracts-ui-components-library";
import { ConstantMapping } from "Configurations/ConstantsMapping";
import GenericDialog from "Components/Dialog/GenericDialog";
import { claimOfferGraphQLCall } from "Services/OfferSerivice";
import ClaimedOffers, {
  ClaimedOffer,
  IClaimedOffers
} from "Models/ReduxModels/ClaimedOffersModel";
import SortedClaimedIds, {
  ClaimIds
} from "Models/ReduxModels/SortedClaimedIds";
import Offers, { ISpinTowWinConfig } from "Models/ReduxModels/OffersModel";
import { getLatestClaimDetailsByClaimId } from "Utils/offerUtils";
import { SpinToWinTypes } from "Models/Interfaces/PreClaimDialogTypes";
import { showSnackBar } from "Utils/SnackBarUtils";
import UserDetails from "Models/ReduxModels/UserDetails";

export interface IProps {
  spinTowinConfig: ISpinTowWinConfig;
  offer: any;
  setShowSTWJourney: (data?) => void;
  submitEmailData: (data?) => void;
  isOnlyOnce?: boolean;
  size?: number;
  upDuration?: number;
  downDuration?: number;
  ctaDetails?: ICTADetails;
  primaryColor?: string;
  contrastColor?: string;
  claimedOffers: IClaimedOffers;
  sortedClaimedIds: ClaimIds;
  offers: any;
  match?: any;
  openWinnerModal: boolean;
  setOpenWinnerModal: (data?) => void;
  openLoserModal: boolean;
  setOpenLoserModal: (data?) => void;
  reFetchConditions: (data?) => void;
  emailCapture: boolean;
  setEmailCapture: (data?) => void;
  type: number;
  CMS_spin_to_win_foreground_img: any;
  CMS_spin_to_win_background_img: any;
  CMS_spin_to_win_winner_img: any;
  CMS_spin_to_win_loser_img: any;
  CMS_spin_to_win_brand_logos: any;
  segments: string[];
  segmentColors: string[];
  fontColors: string[];
  fontSizes: string[];
}

export interface ICTADetails {
  label: string;
  colors: string;
}

export interface IRouteParams {
  id: string;
}

const SpinToWin: React.FC<IProps> = props => {
  const {
    offer,
    submitEmailData,
    setShowSTWJourney = () => { },
    isOnlyOnce = true,
    size = window.innerWidth / 3,
    upDuration = 500,
    downDuration = 1500,
    ctaDetails = { label: "SPIN", colors: "#a70303, #a70303" },
    primaryColor = "#d61d24",
    contrastColor = "white",
    claimedOffers,
    sortedClaimedIds,
    offers,
    openWinnerModal,
    setOpenWinnerModal,
    openLoserModal,
    setOpenLoserModal,
    emailCapture,
    setEmailCapture,
    type,
    reFetchConditions,
    CMS_spin_to_win_foreground_img,
    CMS_spin_to_win_background_img,
    CMS_spin_to_win_winner_img,
    CMS_spin_to_win_brand_logos,
    CMS_spin_to_win_loser_img,
    segmentColors,
    segments,
    spinTowinConfig,
    fontColors,
    fontSizes
  } = props;
  const classes = useStyles();
  const history = useHistory();
  const params = useParams<IRouteParams>();
  const { id } = params;
  const claimedOffer = getLatestClaimDetailsByClaimId(
    offers[offer?.offerId].claimedIds,
    claimedOffers
  );
  const [winnerLabel, setWinnerLabel] = useState<string>("");
  const [isSpinStarted, setIsSpinStarted] = useState(false);
  const loserScreenCTAText = spinTowinConfig?.spin_to_win_loser_cta || ConstantMapping[getClientName()].LOSER_SCREEN_CTA_FALLBACK;
  const spinPointerColor = spinTowinConfig?.spin_to_win_pointer_color || "#a70303,#a70303,#a70303,#a70303";

  const offerPrizeDetails = offer?.offerPrizeDetails

  const onFinished = winnerData => {
    setTimeout(() => {
      const winnerPrizeName = winnerData?.data?.claimOffer?.prizeName;
      const winnerPrizeLabel = offerPrizeDetails?.filter(item => item?.prizeName === winnerPrizeName)?.[0]?.winnerLabel;
      const winnerType = winnerData?.data?.claimOffer?.prizeType;
      setWinnerLabel(winnerPrizeLabel);
      if (winnerType === ConstantMapping[getClientName()].LOSER_PRIZE) {
        setOpenLoserModal(true);
      } else {
        setOpenWinnerModal(true);
      }
    }, 1000);
  };

  const goBack = () => {
    setTimeout(() => {
      setShowSTWJourney(false);
    }, 500);
  };

  const redirectToHome = () => {
    setTimeout(() => history && history.push("/home"), 500);
  };

  const claimHandler = () => {
    const redemptionOfferData = offer?.redemptionDetails?.filter(
      item => item?.prizeName === winnerLabel
    );
    let claimDetails: ClaimedOffer | null = claimedOffer;

    if (redemptionOfferData?.[0]?.captureEmail) {
      setEmailCapture(true);
    } else {
      if (claimDetails) {
        history.push(`/code/${claimDetails.claimedId}`);
      }
    }
  };

  const clientName = getClientName();

  const randomString = () => {
    const chars =
      "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".split("");
    const length = 8;
    let str = "";
    for (let i = 0; i < length; i++) {
      str += chars[Math.floor(Math.random() * chars.length)];
    }
    return str;
  };

  const canvasId = useRef(`canvas-${randomString()}`);
  const wheelId = useRef(`wheel-${randomString()}`);
  const dimension = (size + 20) * 2;
  const innerCircleRadius = 20;
  let currentSegment = "";
  let isStarted = false;
  let timerHandle = 0;
  const timerDelay = segments?.length + 10;
  let angleCurrent = 0;
  let angleDelta = 0;
  let canvasContext: CanvasRenderingContext2D | null = null;
  let maxSpeed = Math.PI / (segments?.length * 6);

  const upTime = segments?.length * upDuration;
  const downTime = segments?.length * downDuration;
  let spinStart = 0;
  let frames = 0;
  const centerX = size + 20;
  const centerY = size + 20;

  useEffect(() => {
    if (type === SpinToWinTypes.WIN) {
      setEmailCapture(true);
    } else {
      wheelInit();
      setTimeout(() => {
        window.scrollTo(0, 1);
      }, 0);
    }
  }, [type]);

  const wheelInit = () => {
    initCanvas();
    wheelDraw();
  };

  const initCanvas = () => {
    let canvas: HTMLCanvasElement | null = document.getElementById(
      canvasId.current
    ) as HTMLCanvasElement;

    if (navigator.userAgent.indexOf("MSIE") !== -1) {
      canvas = document.createElement("canvas");
      canvas.setAttribute("width", `${dimension}`);
      canvas.setAttribute("height", `${dimension}`);
      canvas.setAttribute("id", canvasId.current);
      document.getElementById(wheelId.current)?.appendChild(canvas);
    }
    canvas?.addEventListener("click", spinHandler, false);
    canvasContext = canvas?.getContext("2d");
  };

  const spinHandler = async () => {
    if (!isSpinStarted) {
      setIsSpinStarted(true);
      isStarted = true;
      try {
        let res = await claimOfferGraphQLCall(offer?.offerId);
        reFetchConditions();
        let claimedOffer = res.data?.claimOffer;
        let sortedclaimedIds: number[] = sortedClaimedIds?.claimIds;

        if (claimedOffer) {
          let currentClaimedOffer: any = {
            claimedId: claimedOffer?.id,
            offerId: claimedOffer?.offerId,
            attributes: claimedOffer?.attributes,
            byAgent: claimedOffer?.byAgent,
            claimDateTime: new Date(claimedOffer?.claimDateTime),
            expiryDateTime: claimedOffer?.expiryDateTime
              ? new Date(claimedOffer?.expiryDateTime)
              : undefined,
            offerType: claimedOffer?.offerType,
            redemptionCode: claimedOffer?.redemptionCode,
            prizeName: claimedOffer?.prizeName,
            prizeType: claimedOffer?.prizeType,
            prizeEntries: claimedOffer?.prizeEntries
          };
          sortedclaimedIds.splice(0, 0, claimedOffer.id);
          let newClaimedOffers = claimedOffers || {};
          newClaimedOffers[currentClaimedOffer.claimedId] = currentClaimedOffer;

          let updatedOffers = offers;
          if (updatedOffers[id].claimedIds?.length) {
            updatedOffers[id].claimedIds.push(claimedOffer.id);
          } else {
            updatedOffers[id].claimedIds = [claimedOffer.id];
          }

          // updating the prizeEntries value after claiming the offer.
          const updatedOffer = {
            ...offer,
            prizeEntries: claimedOffer?.prizeEntries
          };
          new Offers({ ...offers, [id]: updatedOffer }).$save();

          if (timerHandle === 0 && res?.data?.claimOffer?.prizeName) {
            spinStart = new Date().getTime();
            maxSpeed = Math.PI / (segments?.length * 3);
            frames = 0;
            timerHandle = window.setInterval(
              () => onTimerTick(res),
              timerDelay
            );
          }
        } else {
          console.log("Error__ ", res);
          showSnackBar();
        }
      } catch (error) {
        console.log("Error__ ", error);
        showSnackBar();
      }
    }
  };

  let segmentsAngleData = {};
  const onTimerTick = winningSegmentData => {
    const winningSegment = winningSegmentData?.data?.claimOffer?.prizeName;
    frames++;
    wheelDraw();

    const duration = new Date().getTime() - spinStart;
    let progress = 0;
    let finished = false;
    if (duration < upTime) {
      progress = duration / upTime;
      angleDelta = maxSpeed * Math.sin((progress * Math.PI) / 2);
    } else {
      if (winningSegment) {
        if (currentSegment === winningSegment && frames > segments?.length) {
          // calculating the radians we have to move according to segment angle.
          const winningSegmentCenterAngle = segmentsAngleData[winningSegment]?.center;
          const needleCenterAngle = 270 * (Math.PI / 180);
          const angleDiffrence = needleCenterAngle - winningSegmentCenterAngle;
          angleCurrent += angleDiffrence;
          wheelDraw();
          progress = 1;
        } else {
          progress = duration / downTime;
          angleDelta =
            maxSpeed * Math.sin((progress * Math.PI) / 2 + Math.PI / 2);
        }
      }
      if (progress >= 1) finished = true;
    }

    angleCurrent += angleDelta;
    while (angleCurrent >= Math.PI * 2) angleCurrent -= Math.PI * 2;
    if (finished) {
      onFinished(winningSegmentData);
      clearInterval(timerHandle);
      timerHandle = 0;
      angleDelta = 0;
    }
  };

  const wheelDraw = () => {
    clear();
    drawWheel();
    drawNeedle();
  };

  const drawSegment = (key: number, lastAngle: number, angle: number) => {
    if (!canvasContext) return;

    const ctx = canvasContext;
    const value = segments[key];
    const colorSet = segmentColors[key % segmentColors.length]?.split(", ");

    // Add spacing between segments (optional)
    const gapSize = 0;
    const adjustedLastAngle = lastAngle + gapSize / 2;
    const adjustedAngle = angle - gapSize / 2;
    segmentsAngleData[value] = {
      start: adjustedLastAngle,
      end: adjustedAngle,
      center: (adjustedLastAngle + adjustedAngle) / 2,
    }


    // --- Segment Fill Gradient ---
    const gradient = ctx.createLinearGradient(0, 0, dimension, 0);
    gradient.addColorStop(0, colorSet[0]);
    gradient.addColorStop(0.33, colorSet[1]);
    gradient.addColorStop(0.66, colorSet[2]);
    gradient.addColorStop(1, colorSet[3]);

    // Outer segment shape with shadow
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, size, adjustedLastAngle, adjustedAngle, false);
    ctx.closePath();
    ctx.shadowColor = "rgba(0, 0, 0, 0.1)";
    ctx.shadowBlur = 6;
    ctx.shadowOffsetX = 1;
    ctx.shadowOffsetY = 1;
    ctx.fillStyle = gradient;
    ctx.fill();
    ctx.restore();

    // Fake inset shadow
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.arc(centerX, centerY, size, adjustedLastAngle, adjustedAngle, false);
    ctx.closePath();
    const insetGradient = ctx.createRadialGradient(centerX, centerY, size / 2, centerX, centerY, size);
    insetGradient.addColorStop(0.7, "rgba(0,0,0,0)");
    insetGradient.addColorStop(1, "rgba(0,0,0,0.1)");
    ctx.fillStyle = insetGradient;
    ctx.fill();
    ctx.restore();

    // Border line
    ctx.save();
    ctx.beginPath();
    ctx.arc(centerX, centerY, size, adjustedLastAngle, adjustedAngle, false);
    ctx.strokeStyle = "rgba(0, 0, 0, 0.2)";
    ctx.lineWidth = 3;
    ctx.shadowColor = "rgba(0, 0, 0, 0.17)";
    ctx.shadowBlur = 8;
    ctx.stroke();
    ctx.restore();

    // Left border line (white glow)
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(centerX + size * Math.cos(adjustedLastAngle), centerY + size * Math.sin(adjustedLastAngle));
    ctx.shadowColor = "rgba(255, 255, 255, 0.2)";
    ctx.shadowBlur = 6;
    ctx.strokeStyle = "rgba(255, 255, 255, 0.2)";
    ctx.lineWidth = 3;
    ctx.stroke();
    ctx.restore();

    // Right border line (dark)
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(centerX, centerY);
    ctx.lineTo(centerX + size * Math.cos(adjustedAngle), centerY + size * Math.sin(adjustedAngle));
    ctx.shadowColor = "rgba(0, 0, 0, 0.2)";
    ctx.shadowBlur = 6;
    ctx.strokeStyle = "rgba(0, 0, 0, 0.2)";
    ctx.lineWidth = 3;
    ctx.stroke();
    ctx.restore();

    // ---- TEXT LABEL ----
    ctx.save();
    ctx.translate(centerX, centerY);
    const textAngle = (adjustedLastAngle + adjustedAngle) / 2;
    ctx.rotate(textAngle);

    const segmentAngle = adjustedAngle - adjustedLastAngle;
    const segmentArcLength = size * segmentAngle;
    const maxTextWidth = segmentArcLength - 20;
    const isNarrow = segmentAngle < (Math.PI / 8);

    const dynamicFontSize = Number(fontSizes?.[key]);
    ctx.font = `bold ${dynamicFontSize}px VodafoneRgBold`;

    const getLabelColor = (hexColor: string) => {
      hexColor = hexColor.replace("#", "");
      const r = parseInt(hexColor.substring(0, 2), 16);
      const g = parseInt(hexColor.substring(2, 4), 16);
      const b = parseInt(hexColor.substring(4, 6), 16);
      const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
      return brightness < 128 ? "#ffffff" : "#000000";
    };

    ctx.fillStyle = fontColors[key]?.split(",")?.[0] || getLabelColor(colorSet[1]);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";

    const wrapText = (text: string, maxLength = 21): string[] => {
      const words = text.trim().split(" ");
      const lines: string[] = [];
      let currentLine = "";

      for (let word of words) {
        if ((currentLine + word).length + 1 <= maxLength) {
          currentLine += word + " ";
        } else {
          lines.push(currentLine.trim());
          currentLine = word + " ";
        }

        // Only allow 2 lines max
        if (lines.length === 2) return lines;
      }

      if (currentLine.trim()) {
        lines.push(currentLine.trim());
      }

      return lines.slice(0, 2);
    };



    const lines = wrapText(value, Number(spinTowinConfig?.spin_to_win_prize_label_length_for_wrap) || 21);
    const lineHeight = dynamicFontSize + 2;
    const yStart = lines.length === 1 ? 0 : -((lines.length - 1) * lineHeight) / 2;

    const xPos = size / 2 + (segments.length > 6 ? 15 : 10);
    lines.forEach((line, i) => {
      ctx.fillText(line, xPos, yStart + i * lineHeight, maxTextWidth);
    });

    ctx.restore();
  };

  const drawWheel = () => {
    if (!canvasContext) return false;

    const ctx = canvasContext;
    let lastAngle = angleCurrent;
    const len = segments?.length;
    const PI2 = Math.PI * 2;

    // Setup for segment drawing
    ctx.lineWidth = 1;
    ctx.strokeStyle = primaryColor;
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    ctx.font = "normal 12px VodafoneRgBold";

    // Draw each segment
    for (let i = 1; i <= len; i++) {
      const angle = PI2 * (i / len) + angleCurrent;
      drawSegment(i - 1, lastAngle, angle);
      lastAngle = angle;
    }

    // Draw center circle with color gradient
    ctx.beginPath();
    ctx.arc(centerX, centerY, innerCircleRadius, 0, PI2, false);
    ctx.closePath();
    // Create a gradient using the colors in the color set
    const colorSet = spinPointerColor?.split(",");
    const gradient = ctx.createLinearGradient(
      centerX - innerCircleRadius,
      centerY + innerCircleRadius,
      centerX + innerCircleRadius,
      centerY - innerCircleRadius
    );

    gradient.addColorStop(0, colorSet[0]);
    gradient.addColorStop(0.33, colorSet[1]);
    gradient.addColorStop(0.66, colorSet[2]);
    gradient.addColorStop(1, colorSet[3]);
    ctx.fillStyle = gradient;
    ctx.fill();

    // Overlay black-to-white shadow from bottom to top
    ctx.save();
    ctx.beginPath();
    ctx.arc(centerX, centerY, innerCircleRadius, 0, PI2, false);
    ctx.closePath();
    const shadowOverlay = ctx.createLinearGradient(
      centerX,
      centerY + innerCircleRadius,
      centerX,
      centerY - innerCircleRadius
    );
    shadowOverlay.addColorStop(0, "rgba(255, 255, 255, 0.4)");   // Bottom
    shadowOverlay.addColorStop(0.5, "rgba(0, 0, 0, 0)");   // Middle
    shadowOverlay.addColorStop(1, "rgba(255, 255, 255, 0)"); // Top
    ctx.fillStyle = shadowOverlay;
    ctx.fill();
    ctx.restore();

    // Draw half-circle stroke for visual effect
    ctx.lineWidth = 0;
    ctx.strokeStyle = "transparent";
    ctx.beginPath();
    ctx.arc(centerX, centerY, innerCircleRadius, Math.PI / 2, (3 * Math.PI) / 2);
    ctx.stroke();
    ctx.beginPath();
    ctx.arc(centerX, centerY, innerCircleRadius, (3 * Math.PI) / 2, Math.PI / 2);
    ctx.stroke();

    // Draw outer circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, size, 0, PI2, false);
    ctx.closePath();

    // Optional dim mid-circle overlay (commented out)
    // ctx.beginPath();
    // ctx.arc(centerX, centerY, size / 2 + 20, 0, Math.PI * 2, false);
    // ctx.fillStyle = "rgba(0,0,0,0.04)";
    // ctx.fill();
    // ctx.closePath();

    // Draw "Spin" label in the center
    ctx.fillStyle = contrastColor;
    ctx.font = "normal 12px VodafoneRgBold";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(ctaDetails?.label, centerX, centerY);
  };

  const drawNeedle = () => {
    if (!canvasContext) return false;
    const ctx = canvasContext;

    // Triangle coordinates
    const leftX = centerX - 5;
    const rightX = centerX + 5;
    const baseY = centerY - 18;
    const tipY = centerY - 35;

    // Fill the triangle with gradient
    const colorSet = spinPointerColor?.split(",");
    const gradient = ctx.createLinearGradient(
      centerX - innerCircleRadius,
      centerY + innerCircleRadius,
      centerX + innerCircleRadius,
      centerY - innerCircleRadius
    );

    gradient.addColorStop(0, colorSet[0]);
    gradient.addColorStop(0.33, colorSet[1]);
    gradient.addColorStop(0.66, colorSet[2]);
    gradient.addColorStop(1, colorSet[3]);

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(rightX, baseY);
    ctx.lineTo(leftX, baseY);
    ctx.lineTo(centerX, tipY);
    ctx.closePath();
    ctx.fillStyle = gradient;
    ctx.fill();
    ctx.restore();

    // Draw glow on left and right sides only
    ctx.save();
    ctx.lineWidth = 1.5;
    ctx.shadowColor = "rgba(255, 255, 255, 0.93)";
    ctx.shadowBlur = 6;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
    ctx.strokeStyle = "rgba(255, 255, 255, 0.24)"; // invisible stroke

    // Left edge glow
    ctx.beginPath();
    ctx.moveTo(leftX, baseY);
    ctx.lineTo(centerX, tipY);
    ctx.stroke();

    // Right edge glow
    ctx.beginPath();
    ctx.moveTo(rightX, baseY);
    ctx.lineTo(centerX, tipY);
    ctx.stroke();

    ctx.restore();

    // Calculate current segment
    const change = angleCurrent + Math.PI / 2;
    let i =
      segments?.length -
      Math.floor((change / (Math.PI * 2)) * segments?.length) -
      1;
    if (i < 0) i += segments?.length;
    currentSegment = segments?.[i];

    // Show current segment label
    if (isStarted) {
      ctx.save();
      ctx.font = "bold 16px VodafoneRgBold";
      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.fillText(currentSegment, centerX, centerY + size + 50);
      ctx.restore();
    }
  };

  const clear = () => {
    if (!canvasContext) {
      return false;
    }
    const ctx = canvasContext;
    ctx.clearRect(0, 0, dimension, dimension);
  };

  const goToHomeHandler = () => {
    setOpenLoserModal(false);
    history.push("/home");
  };

  return (
    <>
      <Header
        headerText=""
        isHeaderInverted={false}
        svgProps={ConstantMapping[clientName].SVG.headerSvgStyle}
        clientLogoPrimary={getImageDetails(
          ImagesMapping[clientName].clientLogoPrimary,
          ConstantMapping[clientName].CLIENT_ICON_TEXT
        )}
        clientLogoSecondary={getImageDetails(
          ImagesMapping[clientName].clientLogoSecondary,
          ConstantMapping[clientName].CLIENT_ICON_TEXT
        )}
        onSvgSelection={goBack}
        onLogoSelection={redirectToHome}
        isScrollHeader={false}
      />
      <div
        className={classes.spinWinMainContainer}
        style={{
          backgroundImage: `url(${CMS_spin_to_win_background_img?.src})`,
          backgroundSize: "cover"
        }}
      >
        <div className={classes.wheelWrapper}>
          {Object?.keys(offer)?.length ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                width: "100%",
                position: "relative",
                pointerEvents: isSpinStarted && isOnlyOnce ? "none" : "auto"
              }}
              onClick={spinHandler}
              id={wheelId.current}
            >
              {CMS_spin_to_win_foreground_img?.src && (
                <img
                  src={CMS_spin_to_win_foreground_img?.src}
                  height={size * 3 + 190}
                  width={size * 3 + 190}
                  style={{
                    position: "absolute",
                    top: "-8.2rem",
                    left: "-6.3rem"
                  }}
                />
              )}
              <canvas
                id={canvasId.current}
                className={classes.canvasWheelStyle}
                width={dimension}
                height={dimension}
                style={{
                  pointerEvents: isSpinStarted && isOnlyOnce ? "none" : "auto",
                  width:
                    window.innerWidth < 450 && window.innerWidth > 400
                      ? window.innerWidth - 100
                      : window.innerWidth - 80,
                  height:
                    window.innerWidth < 450 && window.innerWidth > 400
                      ? window.innerWidth - 100
                      : window.innerWidth - 80,
                }}
              />
            </div>
          ) : null}

          {CMS_spin_to_win_brand_logos?.src && (
            <div className={classes.brandLogosContainer}>
              <img
                src={CMS_spin_to_win_brand_logos?.src}
                className={classes.brandLogos}
              />
            </div>
          )}

          {/* display the winning label */}
          <Dialog
            open={openWinnerModal}
            PaperProps={{
              classes: {
                root: classes.dialogPaperRoot
              },
              style: {
                backgroundImage: `url(${CMS_spin_to_win_winner_img?.src})`
              }
            }}
          >
            <div className={classes.dialogMidContainer}>
              <p
                className={classes.dialogWinnerLabelDesc}
              >{winnerLabel}</p>

              {claimedOffer?.prizeEntries &&
                claimedOffer?.prizeType ===
                ConstantMapping[getClientName()].GRAND_PRIZE ? (
                <p
                  style={{ marginTop: 0 }}
                  className={classes.dialogWinnerLabelDesc}
                >
                  Number of entries won: {claimedOffer?.prizeEntries}
                </p>
              ) : null}
              <Button
                variant="contained"
                color="secondary"
                className={classes.cliamNowButton}
                onClick={claimHandler}
              >
                {claimedOffer?.prizeType ===
                  ConstantMapping[getClientName()].GRAND_PRIZE
                  ? "Show Entries"
                  : "Claim Now"}
              </Button>
            </div>
          </Dialog>

          {/* display the loser label */}
          <Dialog
            open={openLoserModal}
            PaperProps={{
              classes: {
                root: classes.dialogPaperRoot
              },
              style: {
                backgroundImage: `url(${CMS_spin_to_win_loser_img?.src})`
              }
            }}
          >
            <div className={classes.dialogMidContainer}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.goToHomeCTA}
                onClick={goToHomeHandler}
              >
                {loserScreenCTAText}
              </Button>
            </div>
          </Dialog>

          {/* capture email dialog */}
          <GenericDialog
            openDialog={emailCapture}
            content={"EMAILTYPE"}
            clientName={clientName}
            handleCloseDialog={() => {
              setEmailCapture(false);
              setShowSTWJourney(false);
            }}
            showCloseIcon={true}
            heading="Tell us where to send your prize"
            paperStyle={{ backgroundColor: "transparent", padding: 0 }}
            closeIconBtnStyle={ConstantMapping[clientName].SVG.headerSvgStyle}
            showFullScreenDialog={true}
            showEmailPopUp={true}
            confirmCallback={data => submitEmailData(data)}
            isHeaderTransparent={true}
          ></GenericDialog>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  let claimedOffers = ClaimedOffers.getInsatnce("", state)?.props;
  const sortedClaimedIds = SortedClaimedIds.getInsatnce("", state)?.props;
  const offers = Offers.getInsatnce("", state)?.props;
  const userDetails = UserDetails.getInsatnce("", state)?.props;

  return {
    claimedOffers,
    sortedClaimedIds,
    offers,
    userDetails
  };
};
export default connect(mapStateToProps)(SpinToWin);
